import React, {useEffect, useState} from 'react';
import './index.css';
import {useTranslation} from "react-i18next";
import NoData from "../../components/no-data";
import SvgIcon from "../../components/svg-icon";
import {useSelector} from "react-redux";
import InstrumentIcon from "../../components/instrument-icon";
import Big from "big.js";
import {decrypt, encrypt} from "../../helpers/encryption";
import {LazyLoadImage} from "react-lazy-load-image-component";
import Loading from "../../components/loading";
import {Link} from "react-router-dom";
import RankIcon from "../../components/rank-icon";
import InputCheckbox from "../../components/input-checkbox";


const ChallengeList = (props) => {
    const {t} = useTranslation()
    const {selectedWallet} = useSelector(state => state.authenticationReducer)

    const {loading, challenges} = props

    const [rates, setRates] = useState({})

    const getAmountInConversion = amount => {
        if (!selectedWallet?.code)
            return ''

        if (selectedWallet?.code === 'USDT' || selectedWallet?.code === 'USDC')
            return Big(amount || 0).toFixed(2)

        return Big(amount || 0).times(rates[selectedWallet?.code] || 0).toFixed(['TRY', 'USD', 'USDT'].includes(selectedWallet?.code) ? 2 : 5)
    }

    useEffect(() => {
        const handleFiatRates = e => {

            const data = decrypt(e)
            setRates(data)
        }
        window?.tcpSocket?.emit('fiat:rate', encrypt({
            currency: 'USD'
        }))

        window?.tcpSocket?.on('fiat:rates', handleFiatRates)
    }, [])


    return (
        <>


            {

                loading ? <Loading/> :
                    challenges?.length <= 0 ? <NoData desc={t('challenges.empty')}/> :
                        <div className="game-card-list">
                            {
                                challenges.map((game, index) => (
                                    <Link
                                        to={`/casino/games/${game?.game?.slug}`}
                                        className="game-card" key={index}>
                                        <div className="game-image-wrapper">
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                effect="blur"
                                                threshold="100"
                                                className="game-image"
                                                placeholderSrc={game?.game?.game_website?.image}
                                                src={game?.game?.game_website?.image} alt=""/>
                                        </div>

                                        <div className="game-content">
                                            <h3 className="game-title one-line-ellipsis">{game.title}</h3>
                                            <p className="game-studio">{game.studio}</p>
                                            <div className="game-meta">


                                                <p>
                                                    <span>{t('challenges.minimum_bet')}:</span>
                                                    <span
                                                        id={`challenge-${game.id}`}
                                                        className={'d-flex align-items-center justify-content-center gap-2'}>
                                                            $ {Big(game?.min_bet || 0).toFixed(2)}
                                                        </span>
                                                </p>


                                                <p><span>{t('challenges.multiplier')}:</span>
                                                    <span>{Big(game?.multiplier || 0).toFixed(2)}𝔁</span>
                                                </p>


                                                <p>

                                                    <span>{t('challenges.prize')}:</span>

                                                    <span
                                                        id={`challenge-prize-${game.id}`}
                                                        className={'d-flex align-items-center justify-content-center gap-2'}>
                                                                <InstrumentIcon isSmall={true} code={'USDT'}/>
                                                        {Big(game?.prize || 0).toFixed(2)}
                                                        </span>
                                                </p>
                                            </div>

                                            <div className="challenges">
                                                {
                                                    game?.claimed_by ?
                                                        <div
                                                            className={'d-flex align-items-center justify-content-between'}>
                                                            <span>{t('challenges.claimed-by')}</span>
                                                            {
                                                                game?.customer?.is_public ? <span
                                                                        className="d-flex align-items-center justify-content-center align-items-center gap-1">
                                                            <RankIcon icon={game?.customer?.ranki}/>
                                                                        {game?.customer?.username}
                                                                        </span> :
                                                                    <span
                                                                        className="d-flex align-items-center justify-content-center gap-1">
                                                                                <SvgIcon id={'hidden'} extra={'svg-icon-mini'}/>
                                                                        {t('general.hidden')}
                                                                        </span>
                                                            }
                                                        </div>
                                                        :
                                                        null
                                                }

                                            </div>

                                        </div>
                                        {/*<button className="challenge-btn" onClick={() => console.log('game')}>*/}
                                        {/*    <span>{t('challenges.details')}</span>*/}
                                        {/*</button>*/}
                                    </Link>
                                ))
                            }
                        </div>

            }

        </>

    );
};

export default ChallengeList;
